import React, { useState, useEffect } from 'react'
import { getPrizeInfo, receivePrize, getWxConfig } from '@/api'
import type { Period } from '@/api'
import queryString from 'query-string'
import { Toast } from '@penguin/components'
import { domains, STATS_MAP } from '@/utils'
const index = () => {
  const parsed = queryString.parse(window.location.search) as { type: Period }
  const [prizeInfo, setPrize] = useState({
    followStatus: false, // 是否关注企业微信好友
    receiveStatus: false, // 是否领取优惠券
  })
  const [couponUrl, setCouponUrl] = useState('')
  // 前往优惠券页面
  const checkPrize = () => {
    const couponUrl = domains.h5 + '/user/coupon/assetsList/assetsList'
    window.location.replace(couponUrl)
  }

  const initPrizeInfo = async () => {
    const res = await getPrizeInfo({ couponPeriod: parsed.type })
    setPrize(res)
  }

  useEffect(() => {
    if (parsed?.type) {
      initPrizeInfo()
    }
    getWxConfig().then((res) => {
      const { coupon } = res
      const couponPeriod = parsed?.type || 'one'
      const url = coupon[couponPeriod]?.[0]?.imageUrl
      setCouponUrl(url)
    })
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [STATS_MAP.prize.click, 'CLK'],
    })
  }, [])

  const getPrize = async () => {
    if (!prizeInfo.followStatus) {
      Toast.show('暂不满足领取条件')
      return
    }
    window.aplus_queue.push({
      action: 'aplus.record',
      arguments: [STATS_MAP.prize.click, 'CLK'],
    })
    await receivePrize({ couponPeriod: parsed.type })
    await initPrizeInfo()
    Toast.show('领取成功')
  }

  const status =
    prizeInfo.receiveStatus && parsed.type === 'three'
      ? 1
      : prizeInfo.followStatus && prizeInfo.receiveStatus
      ? 2
      : 3

  return (
    <div className=' flex flex-col items-center h-screen bg-prize'>
      <div className=' relative'>
        <img
          className=' w-full'
          src='//static.qiekj.com/static/web/image/prize-bg_1690423031948.png'
          alt=''
        />
      </div>
      <div className='p-3 w-full rem:mt-[-100px] z-10'>
        <img className=' w-full' src={couponUrl} alt='' />
      </div>
      {status === 1 && (
        <div className=' absolute bottom-0 text-center'>
          <span className=' text-coupon text-sm'>券已放入您的账户，点击“查看优惠券”可查看</span>
          <img
            onClick={checkPrize}
            className=' rem:w-[351px]'
            src='//static.qiekj.com/static/web/image/check-prize-btn_1689818694311.png'
            alt=''
          />
        </div>
      )}
      {status === 2 && (
        <div className=' absolute bottom-0 text-center'>
          <span onClick={checkPrize} className=' text-coupon text-sm flex justify-center'>
            券已放入您的账户，
            <span className=' text-click flex items-center'>
              查看优惠券
              <img
                className='rem:w-[5px] rem:h-[9px] rem:ml-[2px]'
                src='//static.qiekj.com/static/web/image/Stroke_1690453785528.png'
                alt=''
              />
            </span>
          </span>
          <img
            className=' rem:w-[351px]'
            src='//static.qiekj.com/static/web/image/has-get-btn_1689818694311.png'
            alt=''
          />
        </div>
      )}
      {status === 3 && (
        <img
          onClick={getPrize}
          className=' rem:w-[351px] absolute bottom-0'
          src='//static.qiekj.com/static/web/image/get-btn_1689818694311.png'
          alt=''
        />
      )}
    </div>
  )
}

export default index
